import { render, staticRenderFns } from "./ButtonTertiary.vue?vue&type=template&id=08c1db66&scoped=true&"
import script from "./ButtonTertiary.vue?vue&type=script&lang=js&"
export * from "./ButtonTertiary.vue?vue&type=script&lang=js&"
import style0 from "./ButtonTertiary.vue?vue&type=style&index=0&id=08c1db66&scoped=true&lang=scss&"
import style1 from "./ButtonTertiary.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c1db66",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
